<template>
  <div>
    <a-card :bordered="false" class="dashboard-bar-chart" style="width: 100%">
      <a-form
        id="components-form-demo-normal-login"
        class="login-form"
        style="width: 100%"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 8 }"
      >
        <a-form-item class="mb-10" label="原密码：" :colon="false">
          <a-input
            v-model="initPassword"
            type="password"
            placeholder="请输入原密码"
          />
        </a-form-item>
        <a-form-item class="mb-5" label="新密码：" :colon="false">
          <a-input
            v-model="password"
            type="password"
            placeholder="请输入由字母和数字组成的8～20位密码"
          />
        </a-form-item>
        <a-form-item class="mb-5" label="确认新密码：" :colon="false">
          <a-input
            v-model="twoPassword"
            type="password"
            placeholder="请输入由字母和数字组成的8～20位密码"
          />
        </a-form-item>
        <a-form-item>
          <a-row :gutter="24">
            <a-col :span="16" :push="4">
              <div style="line-height: 16px; margin-top: 10px">
                <div class="item">
                  <div class="point"></div>
                  <div>密码设置建议:</div>
                </div>
                <div class="item">
                  <div class="point"></div>
                  <div>至少8个字符</div>
                </div>
                <div class="item">
                  <div class="point"></div>
                  <div>至少含字母和数字，不能包含空格</div>
                </div>
                <div class="item">
                  <div class="point"></div>
                  <div>勿使用其他账号的密码。</div>
                </div>
              </div>
            </a-col>

            <a-col
              :span="12"
              :push="14"
              class="mb-24"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 30px;
              "
            >
              <div>
                <a-button
                  type="primary"
                  block
                  style="width: 100px"
                  html-type="submit"
                  @click="handleSubmit"
                >
                  修改密码
                </a-button>
              </div>
            </a-col></a-row
          >
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import { updatePassword } from "@/api/user";
export default {
  data() {
    return {
      initPassword: "",
      password: "",
      twoPassword: "",
    };
  },
  beforeCreate() {},
  created() {},
  methods: {
    // Handles input validation after submission.
    handleSubmit(e) {
      if (!this.initPassword) {
        this.$message.warning("请输入原密码");
        return;
      }

      if (!this.password) {
        this.$message.warning("请输入新密码");
        return;
      }
      if (!this.twoPassword) {
        this.$message.warning("请确认新密码");
        return;
      }
      if (!this.validatePassword(this.password)) {
        this.$message.warning("请输入由字母和数字组成的8～20位密码");
        return;
      }

      if (this.password != this.twoPassword) {
        this.$message.warning("新密码与确认密码不一致");
        return;
      }

      updatePassword({
        password: this.password,
      })
        .then((res) => {
          console.log(res);
          this.$message.success("修改成功");
          this.handleCancel();
        })
        .catch((err) => {});
    },
    handleCancel() {
      this.initPassword = "";
      this.password = "";
      this.twoPassword = "";
    },

    validatePassword(password) {
      const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{8,20}$/;
      return regex.test(password);
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: #ffffff;
}
.code_class {
  display: flex;
}
.login_title_box {
  font-size: 30px;
  font-weight: bold;
}
.login_out_box {
  display: flex;
  align-items: center;
  justify-content: center;
  .login_out_btn {
    color: #0091fb;
    cursor: pointer;
  }
}
.item {
  display: flex;
  align-items: center;
  .point {
    width: 8px;
    height: 8px;
    background-color: #727272;
    margin-right: 5px;
    border-radius: 50%;
  }
}
</style>
